// BCM-898 · PA10 — Batch QA Release Pending (slide 31). [Lavanya]
// Status 49 (GRN Generated) on PF4 — rendered when the progress bar's UPCOMING
// status is "Batch Released By BMS QA" (the PF4 QA-release step; the resolver
// applies this gate). The Sync SAP QA Check Interface button fires a single
// resetWorkflowPostGrn call (batchResetFor: "QA SAP Sync") — see QAReleaseCard.
import React from "react";
import QAReleaseCard from "../components/common/QAReleaseCard";

const PA10QAReleasePending = ({ row, viewOnly, onRefresh }) => (
  <QAReleaseCard
    row={row}
    title="Batch QA Release Pending"
    subText="This batch is awaiting QA release in SAP. Post-Shipment documents cannot be processed until the QA release is granted."
    rejected={false}
    viewOnly={viewOnly}
    onRefresh={onRefresh}
  />
);

export default PA10QAReleasePending;
